<template>
  <el-drawer
    :visible.sync="treeDialog"
    direction="rtl"
    size="30%"
    @close="treeDialog = false"
  >
    <el-table
      :data="list"
      max-height="650"
      ref="tableRef"
      @selection-change="handleSelection"
    >
      <el-table-column align="center" width="50" type="selection">
      </el-table-column>
      <el-table-column align="center" width="100" label="序号">
        <template slot-scope="scope">
          <div>{{ scope.$index + 1 }}</div>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="功能名称">
        <template slot-scope="scope">
          <div>{{ scope.row.name }}</div>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="功能编码">
        <template slot-scope="scope">
          <div>{{ scope.row.operationCode }}</div>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="描述">
        <template slot-scope="scope">
          <div>{{ scope.row.operationDesc }}</div>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="路径">
        <template slot-scope="scope">
          <div>{{ scope.row.path }}</div>
        </template>
      </el-table-column>
    </el-table>
    <div class="demo-drawer__footer">
      <el-button @click="treeDialog = false">取 消</el-button>
      <el-button type="primary" @click="editPermit" :loading="loading">{{
        loading ? '提交中 ...' : '确 定'
      }}</el-button>
    </div>
  </el-drawer>
</template>
<script>
import { updateRoleOperationApi } from '@/api/user.js';
export default {
  props: ['loadData', 'defaultCheckedNodes', 'menuObj', 'roleId'],
  inject: ['reload'],
  data() {
    return {
      loading: false,
      permitData: {},
      list: [],
      treeDialog: false,
      selectionArray: [],
    };
  },
  mounted() {},
  methods: {
    changeSelection() {
      let vm = this;
      this.list.forEach((item) => {
        console.log(item, item.select == 1);
        if (item.select == 1) vm.$refs.tableRef.toggleRowSelection(item, true);
        console.log(vm.$refs.tableRef);
      });
    },
    handleSelection(value) {
      this.selectionArray = value;
      this.selectionArray.forEach((item) => (item.select = 1));
    },
    async editPermit() {
      this.loading = true;
      console.log(this.selectionArray);
      const array = this.list.filter((item) => {
        const selectObj = this.selectionArray.find(
          (child) => child.operationId == item.operationId
        );

        if (!selectObj) {
          item.select = 2;
          return item;
        }
      });
      let obj = {
        roleId: this.roleId,
        operationDtos: [...array, ...this.selectionArray],
      };
      const res = await updateRoleOperationApi({ ...obj });
      if (res.code === 200) {
        this.$message.success('修改成功');
        this.reload();
      }
      if (!res.data) return this.$messager.error('修改失败');
    },
  },
};
</script>
<style lang="less" scoped>
.demo-drawer__footer {
  position: fixed;
  bottom: 20px;
  right: 20px;
}
</style>